import React from "react";
import MarkerIcon from "./MarkerIcon";
import { DISTANCE_TO_TRIGGER_AUDIO } from "../../map/GPX/Resources";
import QRCode from "qrcode.react";
import { useTranslation } from "react-i18next";
import { useRef } from "react";
import { printQrCodeHTML } from "../../util/PrintQrCodeHTML";

const ConfigTouristicMarker = ({ marker, projectDatas }) => {
  const qrCodeRef = useRef(null);
  const { t } = useTranslation();

  const LOGO_CONNEXION_IMG = "/rm_imgs/logo_connexion.png";

  const handlePrintQRCode = () => {
    const qrCodeElement = qrCodeRef.current;
    if (qrCodeElement) {
      const canvas = qrCodeElement.querySelector("canvas");
      if (canvas) {
        const imgData = canvas.toDataURL();
        const logo = LOGO_CONNEXION_IMG;

        const printWindow = window.open("", "_blank");
        if (printWindow) {
          const content = printQrCodeHTML(logo, imgData);
          printWindow.document.write(content);
          printWindow.document.close();
          printWindow.onload = function () {
            printWindow.print();
          };
        } else {
          console.error(
            "Failed to open print window. Check if pop-ups are blocked."
          );
        }
      } else {
        console.error("No canvas found in QRCode element");
      }
    }
  };
  return (
    <>
      <div className="d-flex ms-4 mt-1 text-start">
        <h6 className="ms-4">
          {t("type")} : {marker.triggerType}
        </h6>
      </div>

      {marker.iconImage && (
        <div className="m-4">
          <p>{t("icon")}</p>
          <MarkerIcon
            projectDatas={projectDatas}
            marker={marker}
            markerIcon={marker.iconImage}
            componentType="Information"
          />
          <br />
        </div>
      )}
      {marker.triggerType === "QR Code" && (
        <div>
          <div className="m-4" ref={qrCodeRef}>
            <QRCode value={`${marker.id}`} />
            <br />
            <button className="buttonsFeatures" onClick={handlePrintQRCode}>
              {t("printQrCode")}
            </button>
          </div>
        </div>
      )}
    </>
  );
};
export default ConfigTouristicMarker;
